module.exports = __webpack_public_path__ + "static/media/ic_attendees.7fe776c9.svg";